module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAJFBMVEUAAADyLjrzP0vyP0vxZm/xYW/xJTIyK2z////809b19fX0y86a+WGSAAAABnRSTlMA/MbGNzcN3OTeAAAAUUlEQVQ4y2MYnIDFMA0LEHZgCEzDCkQZ1LBLJDGIYZdIZEjDAciQ2D0TK9jNsKoDK1hFTYlyHGBUAgPQIz5wJgYqJjiciRpnNsCZcXBntUEJAJtzjQrOmJtxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flag/th@2x.png
// module id = anie
// module chunks = 0